import { Failure } from '../../models/common';
import { ErrorOrFailedPayload, PayloadAction, isErrorPayload } from '../actions/core-actions';

export const getFailure = (action: PayloadAction<ErrorOrFailedPayload>): Failure => {
    const { payload } = action;

    return isErrorPayload(payload) ? payload.error : payload.failure;
};
